module.exports = __webpack_public_path__ + "static/media/bg1.f07497e2.png";